import React from "react";
import { Building2 } from "lucide-react";
import img from "../../assets/images/skillserveacademybuilding.png"

const OfflineTrainingPromo = () => {
  const highlights = [
    {
      gif: "/repair-tools.gif",
      title: "Practical Workshop Training",
      desc: "Hands-on equipment experience"
    },
    {
      gif: "/cpu.gif",
      title: "Transform Technical Education",
      desc: "Master CNC, VMC & CAD/CAM"
    },
    {
      gif: "/form.gif",
      title: "Job Preparation Support",
      desc: "Resume & interview prep"
    },
    {
      gif: "/enterprise.gif",
      title: "Modern Infrastructure",
      desc: "State-of-the-art facilities"
    }
  ];

  return (
    <>
      <style>{`
        .offline-section-wrapper {
          padding: 70px 40px;
          background: linear-gradient(135deg, #fffdf4 0%, #fff9e6 100%);
        }

        .offline-section {
          max-width: 1280px;
          margin: 0 auto;
          display: flex;
          gap: 50px;
          align-items: center;
        }

        .offline-brand-bar {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          background: linear-gradient(135deg, #ffdd33 0%, #f7c42d 100%);
          padding: 10px 18px;
          border-radius: 30px;
          margin-bottom: 25px;
          font-weight: 700;
          font-size: 15px;
          color: #1a1a1a;
          box-shadow: 0 4px 15px rgba(255, 204, 0, 0.25);
        }

        .offline-brand-bar a {
          color: inherit;
          text-decoration: none;
        }

        .offline-content {
          flex: 1;
        }

        .offline-title {
          font-size: 34px;
          font-weight: 700;
          color: #1a1a1a;
          margin-bottom: 15px;
        }

        .offline-desc {
          font-size: 17px;
          line-height: 1.7;
          color: #444;
          margin-bottom: 28px;
          max-width: 90%;
        }

        /* Highlight Cards Grid */
        .offline-highlights {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 16px;
          margin-bottom: 30px;
        }

        .highlight-card {
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 16px 18px;
          background: #ffffff;
          border-radius: 14px;
          box-shadow: 0 3px 12px rgba(0,0,0,0.06);
          border: 1px solid rgba(255, 204, 0, 0.15);
          transition: all 0.3s ease;
        }

        .highlight-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 25px rgba(0,0,0,0.1);
          border-color: #ffcc00;
        }

        .highlight-gif-box {
          width: 64px;
          height: 64px;
          min-width: 64px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }

        .highlight-gif-box img {
          width: 54px;
          height: 54px;
          object-fit: contain;
        }

        .highlight-text-wrap {
          flex: 1;
        }

        .highlight-card-title {
          font-size: 15px;
          font-weight: 700;
          color: #1a1a1a;
          margin: 0 0 4px 0;
        }

        .highlight-card-desc {
          font-size: 13px;
          color: #666;
          margin: 0;
          line-height: 1.4;
        }

        .offline-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 14px 26px;
          background: linear-gradient(135deg, #ffcc00 0%, #f7b800 100%);
          color: #1a1a1a;
          text-decoration: none;
          border-radius: 10px;
          font-weight: 700;
          font-size: 15px;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(255, 204, 0, 0.3);
        }

        .offline-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(255, 204, 0, 0.4);
          background: linear-gradient(135deg, #ffe033 0%, #ffcc00 100%);
        }

        .offline-image-box img {
          width: 480px;
          max-width: 100%;
          border-radius: 14px;
          object-fit: cover;
          box-shadow: 0 8px 30px rgba(0,0,0,0.15);
        }

        @media (max-width: 900px) {
          .offline-section {
            flex-direction: column;
            text-align: center;
          }

          .offline-desc {
            max-width: 100%;
          }

          .offline-highlights {
            grid-template-columns: 1fr 1fr;
            margin: 0 auto 30px auto;
          }

          .highlight-card {
            flex-direction: column;
            text-align: center;
            padding: 18px 14px;
          }

          .highlight-text-wrap {
            text-align: center;
          }

          .offline-image-box img {
            width: 100%;
          }
        }

        @media (max-width: 600px) {
          .offline-section-wrapper {
            padding: 50px 20px;
          }

          .offline-title {
            font-size: 26px;
          }

          .offline-highlights {
            grid-template-columns: 1fr;
            max-width: 350px;
          }

          .highlight-card {
            flex-direction: row;
            text-align: left;
          }

          .highlight-text-wrap {
            text-align: left;
          }

          .highlight-gif-box {
            width: 50px;
            height: 50px;
            min-width: 50px;
          }

          .highlight-gif-box img {
            width: 34px;
            height: 34px;
          }
        }
      `}</style>

      <section className="offline-section-wrapper">
        <div className="offline-section">

          {/* Content Side */}
          <div className="offline-content">

            <div className="offline-brand-bar">
              <Building2 size={18} />
              <a href="http://www.skillserveacademy.in/" target="_blank" rel="noopener noreferrer">
                <span>SkillServe<span style={{ fontWeight: 800 }}>Academy</span></span>
              </a>
            </div>

            <h2 className="offline-title">Hands-on Training That Builds Real Skills</h2>

            <p className="offline-desc">
              At <strong>SkillServeAcademy</strong>, learning stretches beyond screens and slides.
              We place learners directly beside real industrial equipment. CNC setups, VMC machines,
              EV technology modules, PLC stations, and CAD/CAM workbenches form the heart of our
              mechanical and manufacturing training.
            </p>

            {/* Highlight Cards */}
            <div className="offline-highlights">
              {highlights.map((item, index) => (
                <div className="highlight-card" key={index}>
                  <div className="highlight-gif-box">
                    <img src={item.gif} alt={item.title} />
                  </div>
                  <div className="highlight-text-wrap">
                    <h4 className="highlight-card-title">{item.title}</h4>
                    <p className="highlight-card-desc">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <a
              href="http://www.skillserveacademy.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="offline-btn"
            >
              Explore Offline Training →
            </a>
          </div>

          {/* Image Side */}
          <div className="offline-image-box">
            <img
              src={img}
              alt="SkillServe Academy Building"
            />
          </div>

        </div>
      </section>
    </>
  );
};

export default OfflineTrainingPromo;
